import {
  CelebrationDate,
  CelebrationPlace,
  CelebrationTime
} from '@/Domain/Procedures/Celebration'

export class CelebrationInfo {
  private _celebrationPlace: CelebrationPlace
  private _celebrationDate: CelebrationDate
  private _celebrationTime: CelebrationTime

  constructor (
    celebrationPlace: CelebrationPlace,
    celebrationDate: CelebrationDate,
    celebrationTime: CelebrationTime
  ) {
    this._celebrationPlace = celebrationPlace
    this._celebrationDate = celebrationDate
    this._celebrationTime = celebrationTime
  }

  celebrationPlace (): string {
    return this._celebrationPlace.place()
  }

  celebrationDate (): string {
    return this._celebrationDate.date()
  }

  celebrationTime (): string {
    return this._celebrationTime.time()
  }
}
